<template>
<div class="card-wrapper" v-if="cardDetails">
    <div class="image-container">
        <img :src="cardDetails.CardImageUrl" @click="openYouTubeModal()" alt="" :class="{ 'cursor-pointer': cardDetails.VideoUrl }" />

        <span class="time-estimate-tag">{{ cardDetails.TimeEstimateToRead }} MIN</span>
    </div>

    <div class="content-container">
        <div class="info-container">
            <span class="tag">{{ cardDetails.Tag }}</span>

            <h4>{{ cardDetails.Title }}</h4>

            <p>
                {{ cardDetails.ShortSummary }}
            </p>
        </div>
        <div class="cta-container">
            <router-link :to="{name: cardDetails.ArticleName}" class="link" id="linkid">Learn more </router-link>
        </div>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from "@/event-bus.js";
import {
    globalEventConsts,
    routeNameConstants
} from "@/constants.js";

export default {
    name: "ArticleCard",
    props: {
        cardDetails: Object,
    },
    methods: {
        openYouTubeModal() {
            if (this.cardDetails?.VideoUrl.trim()) {
                EventBus.$emit(
                    globalEventConsts.SHOW_YOUTUBE_MODAL,
                    this.cardDetails.VideoUrl
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/navigation/navigation-mixins.scss";

.card-wrapper {
    flex: 0 0 auto;
    max-width: 310px;
    height: 415px;
    border-radius: 5px;
    box-shadow: 0 0 $spacer-three 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;

    .image-container {
        min-height: 1px;
        position: relative;

        .cursor-pointer {
            &:hover {
                cursor: pointer;
            }
        }

        .time-estimate-tag {
            position: absolute;
            top: $spacer-three;
            left: $spacer-three;
            padding: 0 $spacer-four;
            background-color: $red-ten;
            border-radius: 15px;
            @extend %nav-section-header;
        }

        img {
            width: 100%;
            height: 160px;
            display: block;
            border-radius: $spacer-two $spacer-two 0 0;
        }
    }

    .content-container {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        padding: $spacer-four $spacer-five $spacer-five;

        .tag {
            @extend %nav-section-header;
             font-weight: $font-weight-semibold;
        }

        h4,
        p {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            padding-bottom: 0;
            margin-bottom: $spacer-three;
        }

        h4 {
            margin-top: $spacer-three;
            -webkit-line-clamp: 2;
            max-height: 60px;
        }

        p {
            -webkit-line-clamp: 3;
            max-height: 75px;
        }

        .cta-container {
            button {
                background-color: $grayscale-eight;
            }
        }
    }

    @include tablet {
        width: calc(33.3% - 20px);
    }

    @include wide-mobile {
        width: 100%;
    }
}
</style>
